export const version = "ethers/5.7.0";
//# sourceMappingURL=_version.js.map